import { Stack } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';

import { IEmployee } from 'contacts/types';
import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { TextLine } from 'core/elements';

interface IProps extends ICellRendererParams {
  value: IEmployee | null;
}

export const EmployeeCell = ({ value }: IProps) => {
  if (!value?.employeeName && !value?.email) {
    return DEFAULT_PLACEHOLDER;
  }

  return (
    <Stack>
      <TextLine text={getDisplayName(value)} />
      {value.email && <TextLine text={value.email} isSubText />}
    </Stack>
  );
};

export const employeeCellValueFormatter = ({ value }: { value: IEmployee | null }): string => {
  return [getDisplayName(value), value?.email].filter(Boolean).join(' ');
};

const getDisplayName = (value: IEmployee | null): string => {
  return value?.employeeName && value?.employeeId
    ? `${value.employeeName} [${value.employeeId}]`
    : value?.employeeName || DEFAULT_PLACEHOLDER;
};
